import { toLocaleDateString } from "../../../utils/helpers/date-format";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import lock from "./images/lock.svg";
import TradeIn from "./images/trade-in.svg";
import trendingDown from "./images/trending-down.svg";
import comingSoonIcon from "./images/coming-soon.svg";

export const getStripConfiguration = ({
    reserved,
    comingSoon,
    isPriceDrop,
    priceDiff,
    defaultSale,
    defaultDiscount,
    priceDropUpdatedAt,
    showTradeInStrip,
    tradeInPrice,
    isDealerListing
}) =>  {
    if (reserved) {
        return {
            type: "RESERVED",
            stripInfo: {
                label: "This car is currently reserved",
                icon: lock
            }
        };
    }
    if (comingSoon) {
        return {
            type: "COMING_SOON",
            stripInfo: {
                label: "This car is coming soon in stock.",
                icon: comingSoonIcon
            }
        };
    }
    if (showTradeInStrip && tradeInPrice && !isDealerListing) {
        return {
            type: "TRADEIN",
            stripInfo: {
                label: `Trade-in credit of ${makePriceLabelRound(tradeInPrice)} applied on this car`,
                icon: TradeIn
            }
        };
    }
    if (defaultSale) {
        return {
            type: "ON_SALE",
            stripInfo: {
                label: `This car is on sale, giving you savings of ${defaultDiscount}`,
                icon: trendingDown
            }
        };
    }
    if (isPriceDrop) {
        return {
            type: "PRICE_DROP",
            stripInfo: {
                label: `Price dropped by ${priceDiff} on ${toLocaleDateString(priceDropUpdatedAt)}`,
                icon: trendingDown
            }
        };
    }
    return null;
};

export const stylesMapping = {
    PRICE_DROP: "styles.priceDropBackground",
    RESERVED: "styles.reservedBackground",
    ON_SALE: "styles.priceDropBackground",
    TRADEIN: "styles.tradeInBackground",
    COMING_SOON: "styles.comingSoonBackground"
};
